// extracted by mini-css-extract-plugin
export default {"tips":"NewQuestion_tips__YMMyZ","new":"NewQuestion_new__D1eOI","back-to-questions":"NewQuestion_back-to-questions__d5LDY","submit":"NewQuestion_submit__4qcKA"};